import(/* webpackMode: "eager" */ "/app/src/components/template/template.tsx")